import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOSETUNIT,
  GET_VDOSETUNITS,
  GET_VDOSETUNITS_BY_FILTER,
  ADD_VDOSETUNIT,
  UPDATE_VDOSETUNIT,
  DELETE_VDOSETUNIT
} from '@/queries/modules/vdoSet/vdoSetUnit.js';

export async function getVdoSetUnits(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETUNITS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoSetUnits', data.getVdoSetUnits);
      context.commit('setSuccess', null);
      return data.getVdoSetUnits
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getVdoSetUnitsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETUNITS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetUnits', data.getVdoSetUnitsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoSetUnitsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoSetUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOSETUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoSetUnit', data.getVdoSetUnit);
      context.commit('setSuccess', null);
      return data.getVdoSetUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addVdoSetUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOSETUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoSetUnits = [...context.state.vdoSetUnits];
      vdoSetUnits.push(data.addVdoSetUnit);
      context.commit('setVdoSetUnits', vdoSetUnits);
      context.commit('setSuccess', newItemSuccess(data.addVdoSetUnit.sectionNo));

      return data.addVdoSetUnit;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoSetUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOSETUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoSetUnits.findIndex(item => item.id === data.updateVdoSetUnit.id);
      const vdoSetUnits = [
        ...context.state.vdoSetUnits.slice(0, index),
        data.updateVdoSetUnit,
        ...context.state.vdoSetUnits.slice(index + 1)
      ];
      context.commit('setVdoSetUnits', vdoSetUnits);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoSetUnit.sectionNo));

      return data.updateVdoSetUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoSetUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOSETUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.vdoSetUnits.findIndex(item => item.id === data.deleteVdoSetUnit.id);
      const vdoSetUnits = [
        ...context.state.vdoSetUnits.slice(0, index),
        ...context.state.vdoSetUnits.slice(index + 1)
      ];
      context.commit('setVdoSetUnits', vdoSetUnits);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoSetUnit.sectionNo));

      return data.deleteVdoSetUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

